import * as React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import AppLayout from '../Layout'
import Home from '../Pages/home'
import FullScreenLoader from '../Components/loader'
import { SEO_LANDING_ROUTES } from '../Config/seo'

// lazy loading components.
const ContactUs = React.lazy(() => import('../Pages/contactUs'))
const TourVendor = React.lazy(() => import('../Pages/tourVendor'))
const CarRentalFranchise = React.lazy(() => import('../Pages/carRental'))
const CarListing = React.lazy(() => import('../Pages/carListing'))
const CarDetail = React.lazy(() => import('../Pages/carDetail'))
const TravelDestinationDetail = React.lazy(() => import('../Pages/travelDestinationDetail'))
const PopularDestinations = React.lazy(() => import('../Pages/popularDestinations'))
const Payment = React.lazy(() => import('../Pages/payment'))
const AboutUs = React.lazy(() => import('../Pages/aboutUs'))
const DestinationListing = React.lazy(() => import('../Pages/destinationListing'))
const LoyaltyProgram = React.lazy(() => import('../Pages/loyaltyProgram'))
const TermsConditions = React.lazy(() => import('../Pages/TermsConditions'))
const Faqs = React.lazy(() => import('../Pages/Faqs'))
const FaqsToursTransfers = React.lazy(() => import('../Pages/FaqsToursTransfers'))
const Profile = React.lazy(() => import('../Pages/profile'))
const FranchiseOpportunity = React.lazy(() => import('../Pages/franchiseOpportunity'))
const Locations = React.lazy(() => import('../Pages/locations'))
const HtmlSitemap = React.lazy(() => import('../Pages/htmlSitemap'))
const NotFound = React.lazy(() => import('../Pages/notFound'))
const SeoLanding = React.lazy(() => import('../Pages/seoLanding'))

const AppRouting = () => {
    return (
        <AppLayout>
            <Routes>
                <Route path='/' element={<Home />} />
                <Route
                    path='/*'
                    element={
                        <React.Suspense fallback={<FullScreenLoader />}>
                            <Routes>
                                <Route path='/car-listing' element={<CarListing />} />
                                <Route path='/car-detail/:id' element={<CarDetail />} />
                                <Route path='/destination-listing' element={<DestinationListing />} />
                                <Route path='/destination-detail/:slug/:id' element={<TravelDestinationDetail />} />
                                <Route path='/destination-detail/:id' element={<TravelDestinationDetail />} />
                                <Route path='/ContactUs' element={<ContactUs />} />
                                <Route path='/BecomeTourVendor' element={<TourVendor />} />
                                <Route path='/CarRentalFranchise' element={<CarRentalFranchise />} />
                                <Route path='/Profile' element={<Profile />} />
                                <Route path='/popular-destinations' element={<PopularDestinations />} />
                                <Route path='/PopularDestinations' element={<Navigate to='/popular-destinations' replace />} />
                                <Route path='/jamaica-destinations' element={<Navigate to='/popular-destinations' replace />} />
                                <Route path='/destinations/montego-bay' element={<Navigate to='/popular-destinations' replace />} />
                                <Route path='/destinations/ocho-rios' element={<Navigate to='/popular-destinations' replace />} />
                                <Route path='/destinations/negril' element={<Navigate to='/popular-destinations' replace />} />
                                <Route path='/destinations/kingston' element={<Navigate to='/popular-destinations' replace />} />
                                <Route path='/about-us' element={<AboutUs />} />
                                <Route path='/payment' element={<Payment />} />
                                <Route path='/loyalty-program' element={<LoyaltyProgram />} />
                                <Route path='/terms-conditions' element={<TermsConditions />} />
                                <Route path='/faqs' element={<Faqs />} />
                                <Route path='/faqs-tours-transfers' element={<FaqsToursTransfers />} />
                                <Route path='/franchise-opportunity' element={<FranchiseOpportunity />} />
                                <Route path='/locations' element={<Locations />} />
                                <Route path='/sitemap' element={<HtmlSitemap />} />
                                {SEO_LANDING_ROUTES.map((r) => (
                                    <Route
                                        key={r.path}
                                        path={r.path}
                                        element={
                                            <SeoLanding
                                                seoKey={r.key}
                                                bannerTitle={r.key.replace(/-/g, ' ')}
                                                bgImg={r.bg}
                                            />
                                        }
                                    />
                                ))}
                                <Route path='*' element={<NotFound />} />
                            </Routes>
                        </React.Suspense>
                    }
                />
            </Routes>
        </AppLayout>
    )
}

export default AppRouting
